module.exports = __webpack_public_path__ + "img/hover_icon_manejo_de_presupuesto.a0ecd744.svg";